import { render, staticRenderFns } from "./ProblemDelivery.vue?vue&type=template&id=e324454e&scoped=true"
import script from "./ProblemDelivery.vue?vue&type=script&lang=js"
export * from "./ProblemDelivery.vue?vue&type=script&lang=js"
import style0 from "./ProblemDelivery.vue?vue&type=style&index=0&id=e324454e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e324454e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e324454e')) {
      api.createRecord('e324454e', component.options)
    } else {
      api.reload('e324454e', component.options)
    }
    module.hot.accept("./ProblemDelivery.vue?vue&type=template&id=e324454e&scoped=true", function () {
      api.rerender('e324454e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Problem/ProblemDelivery.vue"
export default component.exports